import { ValueGetterParams } from 'ag-grid-community';
import { get } from 'lodash';
import { I4BCellType, I4BColumnConfiguration } from '../configurations';
import { DataLibrary, I4bCellConcept } from '../enums';
import { I4BBasicColumnHeader } from '../headers';
import { HeaderType, I4BColumnHeader } from '../models';
import { BasicColumnOptions, I4BColumnOptions } from '../options';
import { I4BColumn } from './i4b-column';

export class DaliaModeDateTimeColumn implements I4BColumn<I4BBasicColumnHeader, I4BColumnConfiguration, I4BColumnOptions> {
  columnId = 'a024bd54-9fc3-11ec-9da8-1123a40210d0-dalia-mode-date-time';
  className = DaliaModeDateTimeColumn;

  dataLibs: DataLibrary[] = [DataLibrary.DEVICES];

  header: I4BBasicColumnHeader = new I4BBasicColumnHeader({
    type: HeaderType.BASIC,
    displayName: 'DALIA_MODE_DATETIME'
  });
  configuration: I4BColumnConfiguration = {
    isLink: false,
    position: '',
    id: 'expandedVariables',
    translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.DALIA_MODE_DATETIME',
    sortProperty: '',
    concept: I4bCellConcept.DEVICES,
    isDefault: true,
    isConfigurable: true,
    width: 170,
    cell: {
      type: I4BCellType.DATE
    }
  };
  options: I4BColumnOptions = new BasicColumnOptions({ sortable: true });

  constructor(customHeader?: Partial<I4BColumnHeader>, customConfig?: Partial<I4BColumnConfiguration>, customOptions?: Partial<I4BColumnOptions>) {
    if (customHeader) {
      this.header = new I4BBasicColumnHeader({
        ...this.header,
        ...customHeader
      });
    }
    if (customConfig) {
      this.configuration = {
        ...this.configuration,
        cell: { ...this.configuration.cell, ...customConfig.cell }
      };
    }
    if (customOptions) {
      this.options = { ...this.options, ...customOptions };
    }
    this.configuration.cell.valueGetter = (params: ValueGetterParams) => {
      const expandedVariables = get(params, 'data.expandedVariables');
      const tm = get(expandedVariables, ['tm', 'lastValue']);
      const fm = get(expandedVariables, ['fm', 'lastValue']);
      const mm = get(expandedVariables, ['mm', 'lastValue']);
      if (tm?.value === 1) {
        return tm?.datetime;
      } else if (fm?.value === 1) {
        return fm?.datetime;
      } else if (mm?.value === 1) {
        return mm?.datetime;
      }
      return null;
    };
  }
}
